module.exports = __webpack_public_path__ + "static/media/webd4.4a9591ad.jpg";